import { Suspense, lazy, useEffect, useState } from "react";
import { Accordion, Badge, Button, Card, Col, Dropdown, Modal, Table } from "react-bootstrap"
import AddSubjects from './AddSubjects';
import { GetAllSubjects } from '../../../services/CommonService';
import EventBus from "../../../services/EventBus";
import Pagination from "react-js-pagination";
import Topics from "./Topics";

function Subjects() {
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>
    );
    useEffect(() => {
        getAllSubjects()

        EventBus.on("loadpagedata", (data) => {
            let obj = {
                payload: {
                    "pageNo": data?.message?.page,
                    "size": 10
                }
            }
            loadData(data?.message?.page);
            //dispatch(fetchAllPaitentsForMedicalBoard({obj:obj}));
        });
        EventBus.remove("loadpagedata");
    }, [])
    const [postModal, setPostModal] = useState(false);
    const [subjects, setSubjects] = useState([]);
    const [updateSubjects, setUpdateSubjects] = useState({})
    const [activePage, setActivePage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [data, setData] = useState([]);
    const [postModal1, setPostModal1] = useState(false);
    const [topicData, setTopicData] = useState({})

    const handlePageChange = async (pn) => {
        if (pn !== activePage && !isNaN(pn)) {
            loadNextsetofRecords(pn);
        }
    };
    const loadNextsetofRecords = async (pn) => {
        setActivePage(pn);
        EventBus.dispatch("loadpagedata", {
            message: {
                "page": pn
            }

        });
    };
    const loadData = async (pn) => {

        const reqparams = {
            pageno: pn,
        }
        const ResponseData = await GetAllSubjects(reqparams);
        setSubjects(ResponseData.data.docs)
        setTotalRecords(ResponseData.data.totalDocs);

    }


    const getAllSubjects = async () => {
        const reqparams = {
            pageno: 1,
        }
        const ResponseData = await GetAllSubjects(reqparams);
        // console.log("Subjects Response",ResponseData.data);
        setSubjects(ResponseData?.data?.docs)
        setTotalRecords(ResponseData?.data?.totalDocs);
    }
    const openModal = async () => {
        setUpdateSubjects({})
        setPostModal(true);
    }
    const closemodal = async () => {
        getAllSubjects()
        setPostModal(false);

    }
    const updateItem = async (item) => {
        setUpdateSubjects(item)
        setPostModal(true)
    }
    const openTopicModel = async (item) => {
        setTopicData(item)
        setPostModal1(true)

    }
    const closemodal1 = async () => {
        setPostModal1(false)
    }
    return (
        <>
            <Card>
                <Card.Header>
                    <Card.Title>Subjects <Button onClick={() => openModal()}
                        className="me-2" variant="primary btn-square"
                        title="Add Subjects"
                    >
                        <span className="btn-icon-start text-danger">
                            <i className="fa fa-plus color-danger" />
                        </span>
                        ADD
                    </Button></Card.Title>
                </Card.Header>
                <Card.Body>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th className="width80">
                                    <strong>Display Order</strong>
                                </th>
                                <th>
                                    <strong>Subject Name</strong>
                                </th>

                                <th>
                                    <strong>Status</strong>
                                </th>

                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {subjects?.map(item => (
                                <tr key={item.id} >
                                    <td>
                                        <strong>{item.position}</strong>
                                    </td>
                                    <td>{item.name}</td>
                                    <td>{item.status}</td>
                                    <td></td>

                                    <td>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="success"
                                                className="light sharp i-false"
                                            >
                                                {svg1}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => updateItem(item)}>

                                                    Edit

                                                </Dropdown.Item >


                                                <Dropdown.Item onClick={() => openTopicModel(item)}>

                                                    Add Topics

                                                </Dropdown.Item >
                                                

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    <div >

                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            activeClass="active"
                            itemClass="page-item"
                            innerClass="pagination mb-0"
                            linkClass="page-link"
                            firstPageText="First"
                            lastPageText="Last"
                            prevPageText="Previous"
                            nextPageText="Next"
                            disabledClass="disabled"
                            activeLinkClass="disabled"
                        />
                    </div>
                </Card.Body>

            </Card>
            <Modal className="modal fade" size="lg" show={postModal} onHide={setPostModal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">

                                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                                <Suspense fallback={<div>Loading</div>}>
                                    <AddSubjects updateprop={updateSubjects} />
                                </Suspense>
                            </div>

                        </form>

                    </div>
                </div>
            </Modal>

            <Modal className="modal fade" size="xl" show={postModal1} onHide={setPostModal1} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">

                                <button type="button" className="btn-close" onClick={closemodal1} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">


                                <Suspense fallback={<div>Loading</div>}>
                                    <Topics topicprops={topicData} />
                                </Suspense>


                            </div>

                        </form>

                    </div>
                </div>
            </Modal>
        </>
    )
}

export default Subjects